var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0804 18.8021H15.8224V13.8761C15.8224 12.7013 15.8008 11.1897 14.1279 11.1897C12.4312 11.1897 12.1712 12.4691 12.1712 13.7914V18.8021H8.91436V8.6718H12.0423V10.0558H12.0856C12.7238 9.00341 13.9091 8.37471 15.1713 8.41969C18.4736 8.41969 19.0814 10.5171 19.0814 13.2443L19.0804 18.8021ZM5.23821 7.28677C4.19377 7.28677 3.34759 6.46978 3.34759 5.46135C3.34759 4.45292 4.19377 3.63592 5.23821 3.63592C6.28266 3.63592 7.12883 4.45292 7.12883 5.46135C7.12883 6.46978 6.28266 7.28677 5.23821 7.28677ZM6.86664 18.8021H3.60545V8.6718H6.86664V18.8021ZM20.7045 0.715239H1.96836C1.08318 0.705824 0.35727 1.39101 0.346436 2.24567V20.41C0.35727 21.2657 1.08318 21.9509 1.96836 21.9414H20.7045C21.5918 21.9519 22.321 21.2667 22.3329 20.41V2.24462C22.3199 1.38787 21.5907 0.702686 20.7045 0.714193",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInWhite);
export default __webpack_public_path__ + "static/media/linkedIn_white.f734a7f8237d5bd77979eef2928eae2e.svg";
export { ForwardRef as ReactComponent };